import sanitizeHtml from "sanitize-html"

export function isContentPresent(stringData: string, allowedTags = []): Boolean {
  return !!sanitizeHtml(stringData || "", { allowedTags })
    .replaceAll(/\s+/g, " ")
    .trim()
}
